(function (Drupal, $) {
  Drupal.behaviors.dennysLinks = {
    attach: function attach(context) {
      $('a[rel*=external]').click(function(e) {
        e.preventDefault();
        window.open(this.href);
      });
    }
  }
})(Drupal, jQuery);
